import { Injectable } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SearchClientService } from '@mode/algolia/domain';
import { DatasourceDomain } from '@mode/shared/contract-common';
import { Definition, QueryOptions } from '@mode/shared/data-access-algolia';
import columnHelpers from './column-suggestion-helper';
import { parseMatchTables } from './table-provider';
import { SuggestionService } from './suggestion.service';
import { SuggestionObservabilityService } from '@mode/shared/util-observability';

@Injectable()
export class AlgoliaSuggestionService implements SuggestionService {
  constructor(
    private _searchClientService: SearchClientService,
    private _o11yService: SuggestionObservabilityService
  ) {}

  async getTables(
    datasource: DatasourceDomain.Datasource,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    opts: QueryOptions<any>,
    isCompletingDefinition: boolean
  ) {
    const queryResults = await this._o11yService.logRequestDurations(this._searchClientService.query(opts), 'algolia');
    return parseMatchTables(datasource, queryResults, isCompletingDefinition);
  }

  async getColumns(
    datasource: DatasourceDomain.Datasource,
    opts: QueryOptions<'table' | 'dataSourceTable'>,
    suggestedTable: string
  ) {
    const indexedBy = datasource.public ? 'table' : 'dataSourceTable';
    const queryResults = await this._o11yService.logRequestDurations(this._searchClientService.query(opts), 'algolia');
    let columns: AceAjax.Completion[] = [];

    if (suggestedTable !== '') {
      const [table = ''] = queryResults[indexedBy];
      columns = columnHelpers.getColumnsInTable(table);
    } else {
      columns = columnHelpers.parseMatchedColumnsBy(queryResults, indexedBy);
    }

    return columns;
  }

  async getDefinition(opts: QueryOptions<'definition'>): Promise<Definition> {
    const queryResults = await this._o11yService.logRequestDurations(this._searchClientService.query(opts), 'algolia');
    return queryResults.definition[0] ?? null;
  }
}
